__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "edison365-admin";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.9.0", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(26729))))));
			register("@emotion/styled", "11.8.1", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(24524))))));
			register("@mui/lab", "5.0.0-alpha.76", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(14820))))));
			register("@mui/material", "5.6.0", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(26024))))));
			register("react-dnd-html5-backend", "14.1.0", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(44854))))));
			register("react-dnd", "14.0.5", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(47716))))));
			register("react-dom", "17.0.2", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(73935))))));
			register("react-hook-form", "7.29.0", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(87536))))));
			register("react-i18next", "11.16.2", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(99777))))));
			register("react-redux", "7.2.8", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(28216))))));
			register("react-router-dom", "5.3.0", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(23338))))));
			register("react", "17.0.2", () => (__webpack_require__.e(970).then(() => (() => (__webpack_require__(67294))))));
			initExternal(41404);
			initExternal(7632);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};